module.exports = __webpack_public_path__ + "img/CARBON-FOOTPRINT.32e3e037.png";